module.exports = __webpack_public_path__ + "img/ine-badge.50db33b3.png";